import script from "./BarThickness.vue?vue&type=script&setup=true&lang=js"
export * from "./BarThickness.vue?vue&type=script&setup=true&lang=js"

import "./BarThickness.vue?vue&type=style&index=0&id=08a40562&lang=scss"

const __exports__ = script;

export default __exports__